/* Horizontal scroll-row arrows (ported from the prototype's main.js).
   Event delegation so it works for every [data-scroll-row] section on the
   page — including ones re-rendered by the Theme Editor — without re-binding.
   The "Watch It In Action" section ships its own arrow logic (card-width
   stepping), so its buttons are skipped here to avoid double scrolling. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-scroll-prev]');
    var next = e.target.closest('[data-scroll-next]');
    var btn = prev || next;
    if (!btn) return;
    if (btn.closest('.watch-in-action-container')) return;

    var wrap = btn.closest('[data-scroll-row]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-scroll-track]');
    if (!track) return;

    var delta = track.clientWidth * 0.8;
    track.scrollBy({ left: prev ? -delta : delta, behavior: 'smooth' });
  });
})();
